document.addEventListener("DOMContentLoaded", function () {
  var eventHub = new Vue();

  //check if app4 exist
  var element = document.getElementById("locations-app-4");
  if (typeof element != "undefined" && element != null) {
    var app4 = new Vue({
      el: "#locations-app-4",
      delimiters: ["${", "}"],
      data: {
        selectedLocation: null,
        productsIds: [],
        variantsIds: [],
        inventories: [],
        loading: false,
        ship_direct: false,
      },
      created() {
        _.each(document.querySelectorAll("[data-vv-id]"), (el) => {
          if (
            el.getAttribute("data-vv-id") != undefined &&
            el.getAttribute("data-vv-id") != ""
          ) {
            this.variantsIds.push(el.getAttribute("data-vv-id"));
          }
        });
        _.each(document.querySelectorAll("[data-vp-id]"), (el) => {
          if (
            el.getAttribute("data-vp-id") != undefined &&
            el.getAttribute("data-vp-id") != ""
          ) {
            this.productsIds.push(el.getAttribute("data-vp-id"));
          }
        });
        eventHub.$on("selectedLocationChange", (value) => {
          this.selectedLocation = value;
          this.getProductsInventories();
          window.setZapietLocation(value.id);
        });

        eventHub.$on("shipDirectChange", (value) => {
          this.ship_direct = value;
        });
      },
      methods: {
        getProductsInventories() {
          if (this.productsIds.length > 0) {
            this.loading = true;
            axios
              .get(
                "https://zurchersinventorysync.com:8443/api/products_by_location",
                {
                  params: {
                    location_id: this.selectedLocation.id,
                    product_ids: this.productsIds.join(","),
                  },
                  headers: {
                    "Api-Token":
                      "OIOq9LNpcq2VvujvPIiKl7Ckzrj1ZgV3W9bGOi84Z2Cib8mYWU",
                  },
                }
              )
              .then((response) => {
                if (response.data.success) {
                  this.inventories = response.data.data;
                  this.loading = false;
                }
              })
              .catch(function (error) {
                console.error(error);
                eventHub.$emit("shipDirectChange", true);
              });
          }
        },
        findStockQtyForVariant(variant_id) {
          if (variant_id != undefined) {
            let variant = _.first(
              _.filter(this.inventories, (inventory) => {
                return inventory.variant_id == variant_id;
              })
            );

            return variant ? (variant.qty ? variant.qty : 0) : 0;
          } else {
            return 0;
          }
        },
      },
    });
  }

  //check if app3 exist
  var element = document.getElementById("locations-app-3");
  if (typeof element != "undefined" && element != null) {
    var app3 = new Vue({
      el: "#locations-app-3",
      delimiters: ["${", "}"],
      data: {
        selectedLocation: null,
        productId: null,
        variantId: null,
        inventories: [],
        loading: false,
        ship_direct: false,
      },
      created() {
        let el = document.getElementById("locations-app-3");

        if (
          el.getAttribute("data-vv-id") != undefined &&
          el.getAttribute("data-vv-id") != ""
        ) {
          this.productId = el.getAttribute("data-vp-id");
          this.variantId = el.getAttribute("data-vv-id");
        }
        eventHub.$on("selectedLocationChange", (value) => {
          this.selectedLocation = value;
          this.getProductInventory();
        });
        eventHub.$on("shipDirectChange", (value) => {
          this.ship_direct = value;
          this.checkAddToCartDiv();
        });
      },
      computed: {
        stockForVariant() {
          return this.findStockQtyForVariant(this.variantId);
        },
        stockShouldBeReported() {
          let variant = this.findVariant(this.variantId);

          return variant && variant.track_inventory ? true : false;
        },
      },
      methods: {
        checkAddToCartDiv() {
          let addToCartDiv = document.getElementById("add-to-cart-pdp");
          if (this.ship_direct) {
            addToCartDiv.classList.remove("tw-hidden!");
          } else if (
            !this.ship_direct &&
            this.findStockQtyForVariant(this.variantId) <= 0
          ) {
            addToCartDiv.classList.add("tw-hidden!");
          } else if (
            !this.ship_direct &&
            this.findStockQtyForVariant(this.variantId) > 0
          ) {
            addToCartDiv.classList.remove("tw-hidden!");
          }
        },
        getProductInventory() {
          if (this.productId) {
            this.loading = true;
            axios
              .get(
                "https://zurchersinventorysync.com:8443/api/products_by_location",
                {
                  params: {
                    location_id: this.selectedLocation.id,
                    product_ids: this.productId,
                  },
                  headers: {
                    "Api-Token":
                      "OIOq9LNpcq2VvujvPIiKl7Ckzrj1ZgV3W9bGOi84Z2Cib8mYWU",
                  },
                }
              )
              .then((response) => {
                if (response.data.success) {
                  this.inventories = response.data.data;
                  this.loading = false;
                  this.checkAddToCartDiv();
                }
              })
              .catch(function (error) {
                console.error(error);
                eventHub.$emit("shipDirectChange", true);
              });
          }
        },
        findStockQtyForVariant(variant_id) {
          if (variant_id != undefined) {
            let variant = this.findVariant(variant_id);

            return variant ? (variant.qty ? variant.qty : 0) : 0;
          } else {
            return 0;
          }
        },
        findVariant(variant_id) {
          if (variant_id != undefined) {
            let variant = _.first(
              _.filter(this.inventories, (inventory) => {
                return inventory.variant_id == variant_id;
              })
            );
            return variant ? variant : undefined;
          } else {
            return undefined;
          }
        },
        enableShipDirect() {
          this.ship_direct = !this.ship_direct;
          localStorage.setItem("v-location-app-ship_direct", this.ship_direct);
          eventHub.$emit("shipDirectChange", this.ship_direct);
        },
      },
    });
  }

  //check if app2 exist
  var element = document.getElementById("locations-app-2");
  if (typeof element != "undefined" && element != null) {
    var app2 = new Vue({
      el: "#locations-app-2",
      delimiters: ["${", "}"],
      data: {
        selectedLocation: null,
        productsIds: [],
        variantsIds: [],
        inventories: [],
        variantsInCart: [],
        loading: false,
        ship_direct: false,
      },
      created() {
        _.each(document.querySelectorAll("[data-vv-id]"), (el) => {
          if (
            el.getAttribute("data-vv-id") != undefined &&
            el.getAttribute("data-vv-id") != ""
          ) {
            this.variantsIds.push(el.getAttribute("data-vv-id"));
          }
        });
        _.each(document.querySelectorAll("[data-vp-id]"), (el) => {
          if (
            el.getAttribute("data-vp-id") != undefined &&
            el.getAttribute("data-vp-id") != ""
          ) {
            this.productsIds.push(el.getAttribute("data-vp-id"));
          }
        });
        eventHub.$on("selectedLocationChange", (value) => {
          this.selectedLocation = value;
          this.getProductsInventories();
        });
        eventHub.$on("shipDirectChange", (value) => {
          this.ship_direct = value;
        });
      },
      methods: {
        getProductsInventories() {
          if (this.productsIds.length > 0) {
            this.loading = true;
            axios
              .get(
                "https://zurchersinventorysync.com:8443/api/products_by_location",
                {
                  params: {
                    location_id: this.selectedLocation.id,
                    product_ids: this.productsIds.join(","),
                  },
                  headers: {
                    "Api-Token":
                      "OIOq9LNpcq2VvujvPIiKl7Ckzrj1ZgV3W9bGOi84Z2Cib8mYWU",
                  },
                }
              )
              .then((response) => {
                if (response.data.success) {
                  this.inventories = response.data.data;
                  this.loading = false;
                }
              })
              .catch(function (error) {
                console.error(error);
                eventHub.$emit("shipDirectChange", true);
              });
          }
        },
        findStockQtyForVariant(variant_id) {
          if (variant_id != undefined) {
            let variant = _.first(
              _.filter(this.inventories, (inventory) => {
                return inventory.variant_id == variant_id;
              })
            );

            return variant ? (variant.qty ? variant.qty : 0) : 0;
          } else {
            return 0;
          }
        },
        addToCart(variant_id, e) {
          if (this.variantIsInCart(variant_id)) {
            this.redirect("/cart");
          } else {
            let target = e.currentTarget;
            let addText = target.querySelector(".add-text");
            let faSpinner = target.querySelector(".fa-spinner");
            let addedText = target.querySelector(".added-text");
            target.classList.toggle("in-cart");
            addText.classList.toggle("tw-hidden!");
            faSpinner.classList.toggle("tw-hidden!");

            axios
              .post("/cart/add.js", {
                id: variant_id,
                quantity: 1,
              })
              .then((response) => {
                this.variantsInCart.push(variant_id);
                faSpinner.classList.toggle("tw-hidden!");
                addedText.classList.toggle("tw-hidden!");
              })
              .catch(function (error) {
                console.error(error);
              });
          }
        },
        redirect(url) {
          window.location.href = url;
        },
        variantIsInCart(variant_id) {
          return _.includes(this.variantsInCart, variant_id);
        },
      },
    });
  }

  var app1 = new Vue({
    el: "#locations-app-1",
    delimiters: ["${", "}"],
    data: {
      showLocationInfo: false,
      showLocationSelector: false,
      locations: [],
      selectedLocation: null,
      searchKey: "",
      ship_direct: false,
      schedules: { ...window.schedules },
      now: moment(),
    },
    created() {
      moment.tz.setDefault("America/Denver");
      axios
        .get("https://zurchersinventorysync.com:8443/api/shopify_locations", {
          headers: {
            "Api-Token": "OIOq9LNpcq2VvujvPIiKl7Ckzrj1ZgV3W9bGOi84Z2Cib8mYWU",
          },
        })
        .then((response) => {
          if (response.data.success) {
            this.locations = response.data.locations;
            this.selectedLocation = this.getDefaultLocation();
            eventHub.$emit("selectedLocationChange", this.selectedLocation);
            this.ship_direct = this.getDefaultShipDirectValue();
            eventHub.$emit("shipDirectChange", this.ship_direct);
          }
        })
        .catch(function (error) {
          console.error(error);
          eventHub.$emit("shipDirectChange", true);
        });

      eventHub.$on("shipDirectChange", (value) => {
        this.ship_direct = value;
      });

      window.ZapietEvent.listen("selected_method", function (checkout_method) {
        if (checkout_method == "delivery" || checkout_method == "shipping") {
          this.ship_direct = true;
          eventHub.$emit("shipDirectChange", this.ship_direct);
        } else {
          this.ship_direct = false;
          eventHub.$emit("shipDirectChange", this.ship_direct);
        }
      });
    },
    computed: {
      filteredLocations() {
        return _.filter(this.locations, (location) => {
          return location.name
            .toLowerCase()
            .includes(this.searchKey.toLowerCase());
        });
      },
    },
    methods: {
      selectLocation(location) {
        this.selectedLocation = location;
        this.showLocationSelector = false;
        localStorage.setItem(
          "v-location-app-default-value",
          this.selectedLocation.id
        );
        eventHub.$emit("selectedLocationChange", this.selectedLocation);
        this.disableShipDirect();
      },
      getDefaultLocation() {
        let session = localStorage.getItem("v-location-app-default-value");
        session =
          session != null && session != undefined
            ? session
            : _.first(this.locations).id;
        return _.find(this.locations, (location) => {
          return location.id == session;
        });
      },
      getDefaultShipDirectValue() {
        let session = localStorage.getItem("v-location-app-ship_direct");
        session = session != null && session != undefined ? session : false;

        return session == "true" || session == true ? true : false;
      },
      enableShipDirect() {
        this.ship_direct = true;
        localStorage.setItem("v-location-app-ship_direct", this.ship_direct);
        eventHub.$emit("shipDirectChange", this.ship_direct);
        this.showLocationInfo = false;
      },
      disableShipDirect() {
        this.ship_direct = false;
        localStorage.setItem("v-location-app-ship_direct", this.ship_direct);
        eventHub.$emit("shipDirectChange", this.ship_direct);
        this.showLocationInfo = false;
      },
      getScheduleLocation(location_id) {
        return _.find(this.schedules.schedules, (location) => {
          return location.locationId == location_id;
        });
      },
      getScheduleDay(schedule_location) {
        return _.find(schedule_location.open_dates, (date) => {
          return date.day_number == this.now.day();
        });
      },
      getScheduleHours(location) {
        let schedule_location = this.getScheduleLocation(location.id);

        if (schedule_location) {
          let schedule_day = this.getScheduleDay(schedule_location);

          let from = moment(schedule_day.from, "hh:mm:ss");
          let to = moment(schedule_day.to, "hh:mm:ss");

          return from.format("h:mmA") + "-" + to.format("h:mmA");
        }

        let from = moment("09:00:00", "hh:mm:ss");
        let to = moment("18:00:00", "hh:mm:ss");

        return from.format("h:mmA") + "-" + to.format("h:mmA");
      },
      isWorkingDay(location_id) {
        if (!this.schedules.hasOwnProperty("schedules")) {
          return false;
        }

        if (this.schedules.hasOwnProperty("holidays")) {
          let isHolyDay = _.find(this.schedules.holidays, (day) => {
            return this.now.isSame(day, "day");
          });

          if (isHolyDay) {
            return false;
          }
        }

        let schedule_location = this.getScheduleLocation(location_id);

        if (schedule_location) {
          let schedule_day = this.getScheduleDay(schedule_location);

          if (!schedule_day.open) {
            return false;
          }
        }

        return true;
      },
      isOpen(location_id) {
        if (!this.isWorkingDay(location_id)) {
          return false;
        }

        let schedule_location = this.getScheduleLocation(location_id);

        if (schedule_location) {
          let schedule_day = this.getScheduleDay(schedule_location);

          let beforeTime = moment(schedule_day.from, "hh:mm:ss");
          let afterTime = moment(schedule_day.to, "hh:mm:ss");

          if (this.now.isBetween(beforeTime, afterTime)) {
            return true;
          }
        }

        return false;
      },
      formatPhone(phone) {
        var cleaned = ("" + phone).replace(/\D/g, "");
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          // var intlCode = match[1] ? "+1 " : "";
          // return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
          return ["(", match[2], ") ", match[3], "-", match[4]].join("");
        }
        return phone;
      },
    },
  });
});
